import React from 'react';
import styles from './DocumentListVault.module.scss';
import { Box, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import CalendarIcon from '../../../../../static/assets/svg/calendar_month.svg';
import { Helpers } from '../../../../common/helpers/helpers';
import { useDocumentsFunctions } from '../../hooks/useDocumentsFunctions';
import EmployeeIcon from '@mui/icons-material/BadgeOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CustomersIcon from '@mui/icons-material/SupportAgentOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import PdfIcon from '../../../../../static/assets/svg/pdf_icon.svg';
import DocxIcon from '../../../../../static/assets/svg/docx_icon.svg';
import BKIcon from '../../../../../static/assets/svg/bk_icon.svg';
import { DocumentsListRowProps } from './types';
import { useTranslation } from 'react-i18next';

export const DocumentsListRow = ({ doc, renderActionButtons }: DocumentsListRowProps) => {
  const { t } = useTranslation();
  const {
    getWorkflow,
    getFileTypeFromName,
    getProfileName,
    getDocumentType,
    getProfileType,
    navigateToDocumentPageTab,
  } = useDocumentsFunctions();
  const renderProfileIcon = (profileType: string) => {
    switch (profileType) {
      case 'employment':
        return <EmployeeIcon fontSize='small' />;
      case 'supplier':
        return <BusinessCenterOutlinedIcon fontSize='small' />;
      case 'customer':
        return <CustomersIcon fontSize='small' />;
      case 'business':
        return <ApartmentOutlinedIcon fontSize='small' />;
      default:
        return null;
    }
  };
  const renderFileTypeIcon = (fileType: string) => {
    switch (fileType.toLowerCase()) {
      case 'pdf':
        return (
          <Tooltip title={t('fileTypes.pdf')} arrow placement='top'>
            <span>
              <PdfIcon />
            </span>
          </Tooltip>
        );
      case 'docx':
        return (
          <Tooltip title={t('fileTypes.msWord')} arrow placement='top'>
            <span>
              <DocxIcon />
            </span>
          </Tooltip>
        );
      case 'doc':
        return (
          <Tooltip title={t('fileTypes.msWord')} arrow placement='top'>
            <span>
              <DocxIcon />
            </span>
          </Tooltip>
        );
      case 'bk':
        return (
          <Tooltip title={t('fileTypes.businessKitz')} arrow placement='top'>
            <span>
              <BKIcon />
            </span>
          </Tooltip>
        );
      default:
        return null;
    }
  };
  const profileType = getProfileType(doc.category);
  const profileIcon = renderProfileIcon(profileType);
  const fileTypeIcon = renderFileTypeIcon(
    'du_filetype' in doc
      ? doc.du_filetype.length > 0
        ? doc.du_filetype[0]
        : getFileTypeFromName(doc.name, doc.contract_generation)
      : 'bk'
  );
  return (
    <TableRow className={styles.table_row}>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 0)}>
        <Box className={styles.profile_container}>
          {profileIcon && <Box className={styles.profile_icon}>{profileIcon}</Box>}
          <Typography variant='body2' className={styles.profile_text}>
            {getProfileName(profileType, doc).join(', ')}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 0)}>
        <Typography variant='body2' className={styles.file_name_container}>
          {doc.name.endsWith('.pdf') || doc.name.endsWith('.docx') || doc.name.endsWith('.doc')
            ? doc.name.replace('.pdf', '').replace('.docx', '').replace('.doc', '')
            : doc.name}
        </Typography>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 0)}>
        <Box className={styles.file_type_container}>
          {fileTypeIcon && <Box className={styles.file_type_icon}>{fileTypeIcon}</Box>}
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 0)}>
        <Typography variant='body2' className={styles.cell_text}>
          {getWorkflow(doc)}
        </Typography>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 0)}>
        <Typography variant='body2' className={styles.cell_text}>
          {getDocumentType(doc)}
        </Typography>
      </TableCell>
      <TableCell className={styles.table_cell} onClick={() => navigateToDocumentPageTab(doc, 0)}>
        <Box className={styles.date_container}>
          <CalendarIcon />
          <Typography variant='body2' className={styles.cell_text}>
            {Helpers.timeStampToDateV2(doc.updated)}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={styles.table_cell}>{renderActionButtons(doc)}</TableCell>
    </TableRow>
  );
};
